import styled from '@emotion/styled';
import { BodyBox, BodyContent, maxBodyWidthPx, pxToRem } from '@lbcamden/lib-react';

export const PropertySelectPageRoot = styled(BodyBox)`
  background-color: ${({ theme }) => theme.colors.secondary};
`;

export const PropertySelectPageSearch = styled(BodyContent)`
  flex: initial;
  padding-bottom: 0 !important;
`;

export const PropertySelectPageList = styled(BodyContent)`
  flex: initial;
  align-items: stretch;
  max-width: ${pxToRem(maxBodyWidthPx)} !important;
`;
